import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=97fffc38&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=ts&"
export * from "./Navigation.vue?vue&type=script&lang=ts&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=97fffc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fffc38",
  null
  
)

export default component.exports